import React from "react";

type CardProps = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  padding?: string;
};

const Card = ({ children, className = "", style, padding = "24px" }: CardProps) => {
  return (
    <div
      className={className}
      style={{
        background: "var(--surface)",
        border: "1px solid var(--border)",
        borderRadius: "24px",
        boxShadow: "var(--shadow)",
        backdropFilter: "var(--glass)",
        WebkitBackdropFilter: "var(--glass)",
        padding,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default Card;